(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mr-hero-slideshow')) {
    class MRHeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(
          this.querySelectorAll('[data-mr-hero-slide]')
        );

        this.currentIndex = Math.max(
          0,
          this.slides.findIndex((slide) =>
            slide.classList.contains('is-active')
          )
        );

        this.intervalMs = Math.max(
          2000,
          Number(this.dataset.interval) || 5000
        );

        this.pauseOnHover =
          this.dataset.pauseOnHover === 'true';

        this.desktopTriptych =
          this.dataset.desktopTriptych === 'true';

        this.desktopMediaQuery =
          window.matchMedia('(min-width: 750px)');

        this.reducedMotion =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          );

        this.timer = null;

        this.handleMouseEnter = () => {
          this.stop();
        };

        this.handleMouseLeave = () => {
          this.start();
        };

        this.handleVisibilityChange = () => {
          if (document.hidden) {
            this.stop();
          } else {
            this.start();
          }
        };

        this.handleBreakpointChange = () => {
          if (
            this.desktopTriptych &&
            this.desktopMediaQuery.matches
          ) {
            this.stop();
          } else {
            this.start();
          }
        };

        if (this.pauseOnHover) {
          this.addEventListener(
            'mouseenter',
            this.handleMouseEnter
          );

          this.addEventListener(
            'mouseleave',
            this.handleMouseLeave
          );
        }

        document.addEventListener(
          'visibilitychange',
          this.handleVisibilityChange
        );

        this.desktopMediaQuery.addEventListener(
          'change',
          this.handleBreakpointChange
        );

        this.start();
      }

      disconnectedCallback() {
        this.stop();

        this.removeEventListener(
          'mouseenter',
          this.handleMouseEnter
        );

        this.removeEventListener(
          'mouseleave',
          this.handleMouseLeave
        );

        document.removeEventListener(
          'visibilitychange',
          this.handleVisibilityChange
        );

        this.desktopMediaQuery.removeEventListener(
          'change',
          this.handleBreakpointChange
        );
      }

      show(index) {
        if (!this.slides.length) return;

        this.currentIndex =
          (index + this.slides.length) %
          this.slides.length;

        this.slides.forEach(
          (slide, slideIndex) => {
            const isActive =
              slideIndex === this.currentIndex;

            slide.classList.toggle(
              'is-active',
              isActive
            );

            slide.setAttribute(
              'aria-hidden',
              isActive ? 'false' : 'true'
            );
          }
        );
      }

      start() {
        this.stop();

        if (this.slides.length < 2) return;

        if (document.hidden) return;

        if (this.reducedMotion.matches) return;

        /*
         * Desktop triptych is static.
         * Autoplay only runs on mobile when enabled.
         */

        if (
          this.desktopTriptych &&
          this.desktopMediaQuery.matches
        ) {
          return;
        }

        this.timer = window.setInterval(() => {
          this.show(this.currentIndex + 1);
        }, this.intervalMs);
      }

      stop() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    customElements.define(
      'mr-hero-slideshow',
      MRHeroSlideshow
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-password-launch"] && !Shopify.designMode) return;
  try {
    
  const mountMRLaunch = (root = document) => {
    const sections = root.matches?.('[data-mr-launch]') ? [root] : Array.from(root.querySelectorAll?.('[data-mr-launch]') || []);
    sections.forEach(section => {
      if (section.dataset.mrMounted === 'true') return;
      section.dataset.mrMounted = 'true';

      const slides = [...section.querySelectorAll('[data-mr-slide]')];
      const dots = [...section.querySelectorAll('[data-mr-dot]')];
      let active = -1;
      let interval = null;
      let countdownTimer = null;
      const delay = Math.max(2000, Number(section.dataset.interval) || 5000);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileScreen = window.matchMedia('(max-width: 749px)');
      const isAutoplay = section.dataset.autoplay === 'true';
      const pagination = section.querySelector('.mr-launch__pagination');
      const getEligibleIndexes = () => slides.reduce((result, slide, index) => {
        const visibility = slide.dataset.deviceVisibility || 'both';
        if (visibility === 'both' || (visibility === 'mobile' && mobileScreen.matches) || (visibility === 'desktop' && !mobileScreen.matches)) result.push(index);
        return result;
      }, []);
      const colorFields = {
        text: '--mr-launch-active-text-color',
        logo: '--mr-launch-active-logo-color',
        eyebrow: '--mr-launch-active-eyebrow-color',
        heading: '--mr-launch-active-heading-color',
        subtitle: '--mr-launch-active-subtitle-color',
        countdown: '--mr-launch-active-countdown-color',
        cta: '--mr-launch-active-cta-color',
        form: '--mr-launch-active-form-color',
        formInput: '--mr-launch-active-form-input-color',
        formSubmit: '--mr-launch-active-form-submit-color',
        formBackground: '--mr-launch-active-form-background'
      };
      const applySlideColors = slide => {
        if (!slide) return;
        Object.entries(colorFields).forEach(([key, name]) => {
          const value = slide.dataset[`color${key[0].toUpperCase()}${key.slice(1)}`];
          if (value) section.style.setProperty(name, value);
          else section.style.removeProperty(name);
        });
        // The password-entry link is outside this section in layout/password.liquid.
        document.body.style.setProperty('--mr-launch-active-password-color', slide.dataset.colorPassword || slide.dataset.colorText || '#fff');
      };

      const playActiveVideos = () => {
        slides.forEach((slide, index) => {
          slide.querySelectorAll('video').forEach(video => {
            const mediaGroup = video.closest('.mr-launch__desktop-media, .mr-launch__mobile-media');
            const visibleOnDevice = mediaGroup && window.getComputedStyle(mediaGroup).display !== 'none';
            if (index === active && visibleOnDevice && !document.hidden && !reducedMotion.matches) {
              video.muted = true;
              const promise = video.play();
              if (promise?.catch) promise.catch(() => {});
            } else {
              video.pause();
            }
          });
        });
      };
      const show = index => {
        const eligible = getEligibleIndexes();
        if (!eligible.length) {
          active = -1;
          slides.forEach(slide => slide.classList.remove('is-active'));
          dots.forEach(dot => { dot.classList.remove('is-active'); dot.setAttribute('aria-current', 'false'); });
          if (pagination) pagination.hidden = true;
          playActiveVideos();
          return;
        }
        active = eligible.includes(index) ? index : (eligible.find(i => i >= index) ?? eligible[0]);
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === active);
          dot.setAttribute('aria-current', i === active ? 'true' : 'false');
        });
        if (pagination) pagination.hidden = eligible.length < 2;
        applySlideColors(slides[active]);
        playActiveVideos();
      };
      const showNext = () => {
        const eligible = getEligibleIndexes();
        if (!eligible.length) return;
        const current = eligible.indexOf(active);
        show(eligible[(current + 1) % eligible.length]);
      };
      const stop = () => { if (interval) window.clearInterval(interval); interval = null; };
      const start = () => {
        stop();
        if (!isAutoplay || getEligibleIndexes().length < 2 || document.hidden || reducedMotion.matches) return;
        interval = window.setInterval(showNext, delay);
      };
      const handleVisibility = () => { playActiveVideos(); if (document.hidden) stop(); else start(); };
      const handleMotion = () => { playActiveVideos(); start(); };
      const handleDeviceChange = () => { show(active); start(); };
      document.addEventListener('visibilitychange', handleVisibility);
      window.addEventListener('resize', playActiveVideos, { passive: true });
      reducedMotion.addEventListener?.('change', handleMotion);
      mobileScreen.addEventListener?.('change', handleDeviceChange);
      dots.forEach((dot, index) => dot.addEventListener('click', () => {
        if (!getEligibleIndexes().includes(index)) return;
        show(index);
        start();
      }));
      // In Shopify Theme Editor, preview the slide whose block is selected.
      const handleBlockSelect = event => {
        const selected = event.target.closest?.('[data-mr-slide]');
        const index = slides.indexOf(selected);
        if (index >= 0 && getEligibleIndexes().includes(index)) {
          show(index);
          stop();
        }
      };
      const handleBlockDeselect = () => start();
      section.addEventListener('shopify:block:select', handleBlockSelect);
      section.addEventListener('shopify:block:deselect', handleBlockDeselect);
      show(0);
      start();

      const shell = section.querySelector('[data-mr-signup]');
      const toggle = section.querySelector('[data-mr-signup-toggle]');
      if (shell && toggle) {
        const setOpen = open => {
          shell.classList.toggle('is-open', open);
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        toggle.addEventListener('click', () => setOpen(!shell.classList.contains('is-open')));
        document.addEventListener('click', e => { if (!shell.contains(e.target)) setOpen(false); });
        document.addEventListener('keydown', e => { if (e.key === 'Escape') setOpen(false); });
        if (shell.querySelector('[data-mr-form-success], .mr-launch__signup-error')) setOpen(true);
      }

      const countdown = section.querySelector('[data-mr-countdown]');
      if (countdown) {
        const target = Date.parse(countdown.dataset.target || '');
        const expired = section.querySelector('[data-mr-countdown-expired]');
        if (Number.isFinite(target)) {
          const update = () => {
            const seconds = Math.max(0, Math.floor((target - Date.now()) / 1000));
            const vals = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
            ['days','hours','minutes','seconds'].forEach((key,i) => { const el = countdown.querySelector(`[data-${key}]`); if (el) el.textContent = String(vals[i]).padStart(2,'0'); });
            if (seconds === 0) { countdown.hidden = true; if (expired) expired.hidden = false; }
          };
          update();
          countdownTimer = window.setInterval(update,1000);
        }
      }
      section.mrDestroy = () => {
        stop();
        if (countdownTimer) window.clearInterval(countdownTimer);
        document.removeEventListener('visibilitychange', handleVisibility);
        window.removeEventListener('resize', playActiveVideos);
        reducedMotion.removeEventListener?.('change', handleMotion);
        mobileScreen.removeEventListener?.('change', handleDeviceChange);
        section.removeEventListener('shopify:block:select', handleBlockSelect);
        section.removeEventListener('shopify:block:deselect', handleBlockDeselect);
        document.body.style.removeProperty('--mr-launch-active-password-color');
        slides.forEach(slide => slide.querySelectorAll('video').forEach(video => video.pause()));
      };
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountMRLaunch(), {once:true});
  } else {
    mountMRLaunch();
  }
  document.addEventListener('shopify:section:load', event => mountMRLaunch(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const wrapper = event.target;
    const instance = wrapper.matches?.('[data-mr-launch]') ? wrapper : wrapper.querySelector?.('[data-mr-launch]');
    instance?.mrDestroy?.();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-slideshow-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = (scope = document) => {
      const roots = scope.matches?.('[data-mr-home-v2]') ? [scope] : Array.from(scope.querySelectorAll?.('[data-mr-home-v2]') || []);
      roots.forEach(root => {
        if (root.dataset.mrHomeMounted === 'true') return;
        root.dataset.mrHomeMounted = 'true';

        const slides = Array.from(root.querySelectorAll('[data-mr-home-slide]'));
        const dots = Array.from(root.querySelectorAll('[data-mr-home-dot]'));
        const dotNav = root.querySelector('.mr-home-v2__dots');
        const arrows = [root.querySelector('[data-mr-h2-prev]'), root.querySelector('[data-mr-h2-next]')].filter(Boolean);
        const h = root.querySelector('[data-mr-h2-heading]');
        const e = root.querySelector('[data-mr-h2-eyebrow]');
        const s = root.querySelector('[data-mr-h2-subtitle]');
        const primary = root.querySelector('[data-mr-h2-button]');
        const content = root.querySelector('.mr-home-v2__content');
        const mobile = window.matchMedia('(max-width:749px)');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        const defaultText = {heading:root.dataset.heading||'',eyebrow:root.dataset.eyebrow||'',subtitle:root.dataset.subtitle||'',buttonLabel:root.dataset.buttonLabel||'',buttonLink:root.dataset.buttonLink||''};
        const delay = Math.max(2000,Number(root.dataset.interval)||7000);
        let active = -1;
        let timer = null;
        let editorSelected = false;
        let hovered = false;

        const eligible = () => slides.map((slide,i)=>({slide,i})).filter(({slide})=>{
          const v = slide.dataset.visibility || 'both';
          return v === 'both' || (mobile.matches ? v === 'mobile' : v === 'desktop');
        }).map(({i})=>i);
        const setText = (node,value) => { if (!node) return; node.textContent=value; node.hidden=!value; };
        const applyContent = slide => {
          if (!slide) return;
          setText(h,slide.dataset.heading||defaultText.heading);
          setText(e,slide.dataset.eyebrow||defaultText.eyebrow);
          setText(s,slide.dataset.subtitle||defaultText.subtitle);
          const label=slide.dataset.buttonLabel||defaultText.buttonLabel;
          const url=slide.dataset.buttonLink||defaultText.buttonLink;
          if (primary) {
            primary.textContent=label;
            primary.hidden=!(label && url);
            if (url) primary.setAttribute('href',url); else primary.removeAttribute('href');
          }
          const colors={text:'--mr-h2-active-text',eyebrow:'--mr-h2-active-eyebrow',heading:'--mr-h2-active-heading',subtitle:'--mr-h2-active-subtitle',button:'--mr-h2-active-button'};
          Object.entries(colors).forEach(([field,css])=>{
            const value=slide.dataset[`color${field[0].toUpperCase()}${field.slice(1)}`];
            if (value) root.style.setProperty(css,value); else root.style.removeProperty(css);
          });
        };
        const playVideo = () => {
          slides.forEach((slide,i)=>slide.querySelectorAll('video').forEach(video=>{
            const grid=video.closest('.mr-home-v2__media-grid');
            const canPlay = i===active && grid && getComputedStyle(grid).display!=='none' && !document.hidden && !reduce.matches;
            if (canPlay) {
              video.muted=true;
              const promise=video.play();
              if (promise?.catch) promise.catch(()=>{});
            } else video.pause();
          }));
        };
        const show = index => {
          const choices=eligible();
          if (!choices.length) {
            active=-1;
            slides.forEach(slide=>{slide.classList.remove('is-active');slide.setAttribute('aria-hidden','true');});
            dots.forEach(dot=>{dot.classList.remove('is-active');dot.setAttribute('aria-current','false');});
            if (content) content.hidden=true;
            if(dotNav) dotNav.hidden=true;
            arrows.forEach(btn=>btn.hidden=true);
            playVideo();
            return;
          }
          if (content) content.hidden=false;
          active=choices.includes(index)?index:(choices.find(i=>i>=index)??choices[0]);
          slides.forEach((slide,i)=>{const selected=i===active;slide.classList.toggle('is-active',selected);slide.setAttribute('aria-hidden',String(!selected));});
          dots.forEach((dot,i)=>{dot.classList.toggle('is-active',i===active);dot.setAttribute('aria-current',String(i===active));});
          if (dotNav) dotNav.hidden=choices.length<2;
          arrows.forEach(btn=>btn.hidden=choices.length<2);
          applyContent(slides[active]);
          playVideo();
        };
        const advance = by => {const choices=eligible();if(!choices.length)return;const at=choices.indexOf(active);show(choices[(at+by+choices.length)%choices.length]);};
        const stop = () => { if(timer)clearInterval(timer);timer=null; };
        const start = () => { stop();if(root.dataset.autoplay!=='true'||editorSelected||(hovered&&root.dataset.pauseHover==='true')||document.hidden||reduce.matches||eligible().length<2)return;timer=setInterval(()=>advance(1),delay); };
        const onVisibility = () => {playVideo();if(document.hidden)stop();else start();};
        const onViewport = () => {show(active);start();};
        const onMotion = () => {playVideo();start();};
        const onMouseEnter = () => {hovered=true;if(root.dataset.pauseHover==='true')stop();};
        const onMouseLeave = () => {hovered=false;start();};
        const onBlockSelect = event => {
          const selected=event.target.closest?.('[data-mr-home-slide]');
          const index=slides.indexOf(selected);
          if(index<0)return;
          editorSelected=true;
          if(eligible().includes(index))show(index);
          stop();
        };
        const onBlockDeselect = () => {editorSelected=false;start();};
        let touchX=null,touchY=null;
        const onTouchStart = event => {const t=event.touches[0];if(t){touchX=t.clientX;touchY=t.clientY;}};
        const onTouchEnd = event => {
          if(touchX===null||touchY===null)return;
          const t=event.changedTouches[0];if(!t)return;
          const dx=t.clientX-touchX,dy=t.clientY-touchY;
          touchX=null;touchY=null;
          if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.25&&eligible().length>1){advance(dx<0?1:-1);start();}
        };

        dots.forEach((dot,index)=>dot.addEventListener('click',()=>{if(!eligible().includes(index))return;show(index);start();}));
        root.querySelector('[data-mr-h2-prev]')?.addEventListener('click',()=>{advance(-1);start();});
        root.querySelector('[data-mr-h2-next]')?.addEventListener('click',()=>{advance(1);start();});
        root.addEventListener('mouseenter',onMouseEnter);
        root.addEventListener('mouseleave',onMouseLeave);
        root.addEventListener('touchstart',onTouchStart,{passive:true});
        root.addEventListener('touchend',onTouchEnd,{passive:true});
        root.addEventListener('shopify:block:select',onBlockSelect);
        root.addEventListener('shopify:block:deselect',onBlockDeselect);
        document.addEventListener('visibilitychange',onVisibility);
        mobile.addEventListener?.('change',onViewport);
        reduce.addEventListener?.('change',onMotion);
        show(0);
        start();

        root.mrHomeDestroy=()=>{
          stop();document.removeEventListener('visibilitychange',onVisibility);
          mobile.removeEventListener?.('change',onViewport);
          reduce.removeEventListener?.('change',onMotion);
          root.removeEventListener('mouseenter',onMouseEnter);
          root.removeEventListener('mouseleave',onMouseLeave);
          root.removeEventListener('touchstart',onTouchStart);
          root.removeEventListener('touchend',onTouchEnd);
          root.removeEventListener('shopify:block:select',onBlockSelect);
          root.removeEventListener('shopify:block:deselect',onBlockDeselect);
          slides.forEach(slide=>slide.querySelectorAll('video').forEach(video=>video.pause()));
        };
      });
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(),{once:true});else mount();
    document.addEventListener('shopify:section:load',event=>mount(event.target));
    document.addEventListener('shopify:section:unload',event=>{
      const el=event.target.matches?.('[data-mr-home-v2]')?event.target:event.target.querySelector?.('[data-mr-home-v2]');
      el?.mrHomeDestroy?.();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
